import { render } from "./MediaChanged.vue?vue&type=template&id=6cd6c815"
import script from "./MediaChanged.vue?vue&type=script&lang=js"
export * from "./MediaChanged.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__